export default __webpack_public_path__ + "static/media/awards.ca0a2f7c.png";